import React from 'react'
import { Box, Typography, Grid } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch } from '@fortawesome/pro-duotone-svg-icons'
import Kedo from '../../../Kedo'
import { LoadingProps } from './loading.types'
import { getPixelSize } from './loadingUtils'

const Loading: React.FC<LoadingProps> = ({
    kedo,
    size = 'md',
    speed = 1.25,
}) => {
    const translator = kedo || new Kedo()
    const pixelSize = getPixelSize(size)

    return (
        <Grid container justifyContent="center" sx={{ marginTop: '50px' }}>
            <Grid size={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                <Box sx={{ textAlign: 'center' }}>
                    <FontAwesomeIcon
                        icon={faCircleNotch}
                        spin
                        style={{
                            fontSize: pixelSize,
                            animationDuration: `${speed}s`,
                        }}
                    />
                    <Typography variant="body2" sx={{ mt: 2 }}>
                        {translator.t('Busy fetching the content')}...
                    </Typography>
                </Box>
            </Grid>
        </Grid>
    )
}

export default Loading
